import serialize from './serialize';
import deserialize from './deserialize';
import Serializer from '../../serializer';

export default {
    serialize,
    deserialize
} as Serializer;
